import { DocumentViewer } from '@enter/core';
import React, { useContext } from 'react';
import { DialogContext, IDialogContextProps } from '../../services';
import * as S from './document.styles';

export function useDocumentView() {
    const dialogContext = useContext(DialogContext) as IDialogContextProps;

    const handleCloseDialog = (): void => {
        dialogContext.hideDialog?.();
    };

    function openFile(url: string, title: string = 'Document') {
        const dialogProps = {
            onClose: handleCloseDialog,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            renderTitle: title,
            showCloseButton: true,
            expandable: true,
            // Set z-index higher than messaging panel (1301) to ensure document viewer appears above it
            style: { zIndex: 1400 },
        };

        dialogContext.showDialog?.({
            props: dialogProps,
            Component: (
                <S.Wrapper>
                    <DocumentViewer url={url} />
                </S.Wrapper>
            ),
        });
    }

    return [openFile];
}
